var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            [
              _c(
                "el-row",
                {
                  staticStyle: { "flex-wrap": "wrap", "align-items": "center" },
                  attrs: { justify: "left", type: "flex" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.RegistrationT"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "90%" },
                            attrs: {
                              clearable: false,
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "collectionCenter.EndTime"
                              ),
                              "range-separator": _vm.$t("collectionCenter.to"),
                              "start-placeholder": _vm.$t(
                                "collectionCenter.StartTime"
                              ),
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.dateChange },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "90%" },
                              on: { change: _vm.numberTypeChange },
                              model: {
                                value: _vm.numberType,
                                callback: function ($$v) {
                                  _vm.numberType = $$v
                                },
                                expression: "numberType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.waybillNumber"),
                                  value: 0,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.ScanNumber"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "3",
                                attrs: {
                                  label: _vm.$t(
                                    "collectionCenter.workOrderNumber"
                                  ),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("br"),
                          _c("el-input", {
                            staticStyle: { width: "90%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.BatchQuery"
                              ),
                              rows: 1,
                              type: "textarea",
                            },
                            on: { blur: _vm.numberBoxChange },
                            nativeOn: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.numberBoxChange($event)
                              },
                            },
                            model: {
                              value: _vm.numberBox,
                              callback: function ($$v) {
                                _vm.numberBox = $$v
                              },
                              expression: "numberBox",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.search },
                        },
                        [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.resetForm },
                        },
                        [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.advancedSearch },
                        },
                        [_vm._v(_vm._s(_vm.$t("home.advancedSearch")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.getSelectedConditions().length
            ? _c(
                "div",
                { staticClass: "selected-conditions" },
                [
                  _c("span", { staticClass: "selected-label" }, [
                    _c("i", { staticClass: "el-icon-filter" }),
                    _vm._v(
                      " " + _vm._s(_vm.$t("seller.selectedConditions")) + ": "
                    ),
                  ]),
                  _vm._l(_vm.getSelectedConditions(), function (item) {
                    return _c(
                      "el-tag",
                      {
                        key: item.key,
                        staticClass: "selected-tag",
                        attrs: { closable: "", size: "medium" },
                        on: {
                          close: function ($event) {
                            return _vm.removeCondition(item.key)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(item.label) +
                            ": " +
                            _vm._s(item.value) +
                            " "
                        ),
                      ]
                    )
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "clear-all-btn",
                      attrs: { type: "text" },
                      on: { click: _vm.clearAllConditions },
                    },
                    [
                      _c("i", { staticClass: "el-icon-delete" }),
                      _vm._v(" " + _vm._s(_vm.$t("seller.clearAll")) + " "),
                    ]
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "btn:quality-service:handover-exception:bulkImport",
                      expression:
                        "'btn:quality-service:handover-exception:bulkImport'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.allImportOrder },
                },
                [_vm._v(_vm._s(_vm.$t("newOrder.bulkImport")) + " ")]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.download } },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.export")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "btn:quality-service:handover-exception:modifyResult",
                      expression:
                        "'btn:quality-service:handover-exception:modifyResult'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.editResult },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.modifyResult")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "btn:quality-service:handover-exception:modifyResult",
                      expression:
                        "'btn:quality-service:handover-exception:modifyResult'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.exportOrderNumberDetailsResult },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("collectionCenter.exportOrderNumberDetails")
                    ) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("searchCom", {
            ref: "searchComRef",
            on: { "child-search": _vm.childSearch },
          }),
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.ticketType,
                callback: function ($$v) {
                  _vm.ticketType = $$v
                },
                expression: "ticketType",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("collectionCenter.tudo"),
                    name: "all",
                  },
                },
                [
                  _c("template", { slot: "label" }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("collectionCenter.tudo")) +
                          " " +
                          _vm._s(_vm.statistics.allQuantity)
                      ),
                    ]),
                  ]),
                ],
                2
              ),
              _c("el-tab-pane", {
                attrs: {
                  disabled: _vm.statistics.reportedQuantity === 0,
                  label:
                    _vm.$t("collectionCenter.myReported") +
                    " " +
                    _vm.statistics.reportedQuantity,
                  name: "1",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  disabled: _vm.statistics.disposeQuantity === 0,
                  label:
                    _vm.$t("collectionCenter.myPending") +
                    " " +
                    _vm.statistics.disposeQuantity,
                  name: "2",
                },
              }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "tableRef",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "max-height": "600",
                "row-key": "id",
              },
              on: { "selection-change": _vm.selectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  fixed: "left",
                  type: "selection",
                  width: "50",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "55",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._l(_vm.tableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.id,
                  attrs: {
                    align: item.align,
                    label: item.label,
                    "min-width": item.cloWidth,
                    prop: item.prop,
                    "show-overflow-tooltip": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "ticketStatusName"
                              ? _c(
                                  "div",
                                  [
                                    scope.row["ticketStatus"] === 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("GlobalSetObj.Pending")
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : scope.row["ticketStatus"] === 2
                                      ? _c("el-tag", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("newOrder.processing")
                                            ) + " "
                                          ),
                                        ])
                                      : scope.row["ticketStatus"] === 3
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "warning" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.partiallyCompleted"
                                                )
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : scope.row["ticketStatus"] === 4
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.fullyCompleted"
                                                )
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _c("span", [_vm._v("--")]),
                                  ],
                                  1
                                )
                              : item.prop === "detailSum"
                              ? _c("div", [
                                  scope.row["detailSum"]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "detailSum_class",
                                          on: {
                                            click: function ($event) {
                                              return _vm.detailMsgClick(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row["detailSum"]) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _c("span", [_vm._v("--")]),
                                ])
                              : _c("div", [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row[item.prop] || "--")
                                    ),
                                  ]),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  fixed: "right",
                  label: "操作（Ação）",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "operation_class" }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "permit",
                                  rawName: "v-permit:remove",
                                  value:
                                    "btn:quality-service:handover-exception:Reply",
                                  expression:
                                    "'btn:quality-service:handover-exception:Reply'",
                                  arg: "remove",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.replyMessage(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Reply")) + " ")]
                          ),
                          scope.row["ticketStatus"] !== 4 &&
                          scope.row["ticketType"] !== 1
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "permit",
                                      rawName: "v-permit:remove",
                                      value:
                                        "btn:quality-service:handover-exception:over",
                                      expression:
                                        "'btn:quality-service:handover-exception:over'",
                                      arg: "remove",
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.processRClick(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("collectionCenter.end")) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.imageOpenClick(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("collectionCenter.picture")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c("el-pagination", {
            staticStyle: { margin: "10px 0", float: "right" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 50, 100, 500, 1000],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.getPageSize,
              "current-change": _vm.handleCurrentChange,
            },
          }),
          _c("div", { staticStyle: { height: "50px" } }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "close-on-click-modal": false,
            title: _vm.$t("basicData.BulkImport"),
            visible: _vm.bulkImportDialogVisible,
            "wrapper-closable": false,
            direction: "ltr",
            size: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.bulkImportDialogVisible = $event
            },
            close: _vm.bulkImportCloseDrawer,
          },
        },
        [
          _c("bulkImport", {
            ref: "bulkImportRef",
            on: {
              bIClose: _vm.bulkImportCloseDrawer,
              toSearch: _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "drawerClass",
          attrs: {
            "close-on-click-modal": true,
            "destroy-on-close": true,
            title: _vm.$t("collectionCenter.messageRecord"),
            visible: _vm.seeDialogVisible,
            direction: "ltr",
            size: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.seeDialogVisible = $event
            },
            close: _vm.closeDrawer,
          },
        },
        [
          _c("messageDetail", {
            ref: "messageDetailRef",
            attrs: { "reply-message-data": _vm.replyMessageData },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.processRClose,
            title: _vm.$t("collectionCenter.processingResult"),
            visible: _vm.processRDialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.processRDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "15px",
                "font-weight": "bold",
                color: "#67696d",
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("GlobalSetObj.totalOptions")) +
                  "：" +
                  _vm._s(_vm.processResultForm.ids.length) +
                  " "
              ),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "processRFormRef",
              staticStyle: { margin: "10px" },
              attrs: { model: _vm.processResultForm, "label-position": "top" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("collectionCenter.processingResult") +
                              "：",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("GlobalSetObj.pleaseChoose"),
                                trigger: "change",
                              },
                            ],
                            prop: "handlingResult",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.processResultForm.handlingResult,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.processResultForm,
                                    "handlingResult",
                                    $$v
                                  )
                                },
                                expression: "processResultForm.handlingResult",
                              },
                            },
                            _vm._l(_vm.processResultList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.processRClose } }, [
                _vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.processRSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.imgClose,
            title: _vm.$t("navbar.seeImage"),
            visible: _vm.imgDialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.imgDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticClass: "imgBox" },
            _vm._l(_vm.srcList, function (item, index) {
              return _c(
                "el-col",
                {
                  key: index,
                  staticStyle: {
                    "margin-bottom": "10px",
                    "margin-right": "10px",
                  },
                  attrs: { span: 7 },
                },
                [
                  _c("el-image", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "preview-src-list": _vm.srcList,
                      src: item,
                      fit: "contain",
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "close-on-click-modal": true,
            "destroy-on-close": true,
            title: _vm.$t("GlobalSetObj.DetailOfwaybill"),
            visible: _vm.waybillDetailVisible,
            direction: "ltr",
            size: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.waybillDetailVisible = $event
            },
            close: _vm.waybillDetailClose,
          },
        },
        [
          _c("waybillDetail", {
            ref: "waybillDetailRef",
            attrs: { "way-id": _vm.waybillId },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }